function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFullscriptLogoLeaf = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 63 54",
  style: {
    enableBackground: "new 0 0 63 54"
  },
  xmlSpace: "preserve",
  role: "img"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M82.4 52v.2c0 .8-1.2 17.6-21.9 25.2V66.9L73 53.3c1.1-1.2 1.1-3.1-.2-4.3-1.2-1.1-3.1-1.1-4.3.2l-8 8.8v-9.1c1-2.3 5.8-11.3 17.6-11.3h.3c4.7 5.6 4 14.3 4 14.4zm-27.9 6-8.1-8.8c-1.1-1.2-3-1.3-4.2-.2-1.2 1.1-1.3 3.1-.2 4.3l12.5 13.6v10.4c-20.7-7.6-21.8-24.5-21.9-25.2v-.2c0-.1-.8-8.8 3.9-14.4h.4c11.9 0 16.6 9.1 17.6 11.3V58zM82 32.4c-.5-.5-1.2-.8-1.9-.9-11.3-.7-18.7 5.1-22.6 10.5-3.9-5.4-11.2-11.2-22.6-10.5-.7 0-1.4.4-1.9.9-7.3 7.3-6.5 18.9-6.4 20 0 .8.5 6.5 4.2 13.1 3.5 6.3 10.9 14.6 25.6 18.8.1 0 .2 0 .2.1h1.6c.1 0 .2 0 .3-.1 27.3-7.7 29.7-29.7 29.8-31.8.1-.6 1.1-12.6-6.3-20.1z",
  style: {
    fill: "#88b04b"
  },
  transform: "translate(-26 -31)"
}));
export default SvgFullscriptLogoLeaf;